var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBudget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.634 18.81a8.727 8.727 0 0 1-5.89 2.274C6.914 21.084 3 17.181 3 12.367 3 7.688 6.698 3.87 11.339 3.66a.375.375 0 0 1 .285.107c.08.075.12.17.12.279v8.198a.3.3 0 0 0 .088.212l5.815 5.797a.372.372 0 0 1 .113.282.373.373 0 0 1-.127.276Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.242 17.593-4.591-4.577a.3.3 0 0 1 .212-.512h6.75c.116 0 .215.046.292.133a.373.373 0 0 1 .09.307 8.676 8.676 0 0 1-2.194 4.636.375.375 0 0 1-.277.126.374.374 0 0 1-.282-.113ZM13.34 10.613V3.386c0-.11.04-.204.12-.279A.375.375 0 0 1 13.743 3c4.225.192 7.668 3.374 8.251 7.472a.372.372 0 0 1-.09.308.376.376 0 0 1-.293.133h-7.973a.3.3 0 0 1-.3-.3Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.df20dadd.svg";
export { ForwardRef as ReactComponent };